// Portfolio.js
import React, { useState } from 'react';
import { useScrollAnimation } from '../animations/ScrollAnimation';
import fjuLogo from '../assets/chatforyou-1.0.png';
import fjuSISProject from '../assets/香聚食嗑.png';

const Portfolio = () => {
  useScrollAnimation();
  const [activeCategory, setActiveCategory] = useState('all');
  
  const projects = [
    { 
      id: 1, 
      title: 'Chat輔U', 
      category: 'web', 
      image: fjuLogo, 
      description: '輔大教務處客服機器人',
      status: 'offline'
    },
    { 
      id: 2, 
      title: '香聚食嗑', 
      category: 'app', 
      image: fjuSISProject, 
      description: '統資系畢業專題－團體推薦系統',
      status: 'unavailable'
    }
  ];

  const filteredProjects = activeCategory === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeCategory);
  
  return (
    <section id="portfolio" className="section portfolio-section">
      <div className="container">
        <h2 className="section-title appear">作品集</h2>
        
        <div className="portfolio-filter appear">
          <button 
            className={activeCategory === 'all' ? 'active' : ''} 
            onClick={() => setActiveCategory('all')}
          >
            全部
          </button>
          <button 
            className={activeCategory === 'web' ? 'active' : ''} 
            onClick={() => setActiveCategory('web')}
          >
            網站
          </button>
          {/*<button 
            className={activeCategory === 'design' ? 'active' : ''} 
            onClick={() => setActiveCategory('design')}
          >
            設計
          </button>*/}
          <button 
            className={activeCategory === 'app' ? 'active' : ''} 
            onClick={() => setActiveCategory('app')}
          >
            應用程式
          </button>
        </div>
        
        <div className="projects-grid">
          {filteredProjects.map((project, index) => (
            <div 
              key={project.id} 
              className="project-card appear"
            >
              <div className="project-image">
                {typeof project.image === 'string' ? (
                  <img src={project.image} alt={project.title} />
                ) : (
                  <img src={project.image} alt={project.title} />
                )}
                <div className="project-overlay">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  {/* 根據專案狀態顯示不同的按鈕或標籤 */}
                  {project.status === 'demo' && (
                    <a href={`#project-${project.id}`} className="view-project">Demo</a>
                  )}
                  
                  {project.status === 'offline' && (
                    <span className="project-status">尚未上線</span>
                  )}
                  
                  {project.status === 'unavailable' && (
                    <span className="project-status">已下架</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;